import React from 'react';
import './App.css';
import ComingSoon from './pages/ComingSoon';

function App() {
  return <ComingSoon />;
}

export default App;
